<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->


<fab-loading-spinner color="primary" *ngIf="showSpinner || industrySpinner || vehicleSpinner || propulsionSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div class="d-flex flex-column gap-8">
  <div id="header-container">
    <div>
      <h1 id="header-text">Vehicle Consolidation Report</h1>
    </div>
    <div>
      <button mat-flat-button color="primary" id="report-button" class="action-button"
              [disabled]="this.selectedScenarios?.length === 0" (click)="getReport()">
        Run Report
      </button>
    </div>
  </div>

  <div class="d-flex flex-column justify-content-center">
    <mat-button-toggle-group [(ngModel)]="scenarioSourceType" (ngModelChange)="resetSelections()"
                             hideSingleSelectionIndicator="true"
                             class="flex max-width">
      <mat-button-toggle id="forecast-org-toggle" [value]="0" class="equal-flex-item">
        By Forecast Org
      </mat-button-toggle>
      <mat-button-toggle id="global-scenario-toggle" [value]="1" class="equal-flex-item">
        By Global Scenario
      </mat-button-toggle>
      <mat-button-toggle id="tvp-toggle" [value]="2" class="equal-flex-item">
        By TVP Scenarios
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="d-flex justify-content-between align-items-center" *ngIf="scenarioSourceType === 2">
    <mat-checkbox [(ngModel)]="showHiddenScenarios" (ngModelChange)="setTables()" id="show-hidden">
      Include Hidden Scenarios
    </mat-checkbox>
    <div class="d-flex gap-16">
      <button mat-flat-button color="primary" id="filter-button" (click)="getFilteredScenarioIds()">
        Filter
      </button>
      <button mat-flat-button color="primary" id="filter-reset-button" (click)="setTables(); resetTVPFilters()">
        Reset Filters
      </button>
    </div>
  </div>
  <div class="flex-container flex-row content-height">

    <div class="w-100 h-100" *ngIf="scenarioSourceType === 2">
      <ag-grid-angular
        style="height: 100%; width:100%;"
        class="ag-theme-quartz"
        [rowData]="displayedTvpScenarios"
        [columnDefs]=DEFAULT_VEHICLE_COL_HEADERS_AGGRID
        [autoSizeStrategy]="autoSizeStrategy"
        [rowSelection]="rowSelection"
        (rowSelected)="onSelectTvp($event)"
      />
    </div>
    <div class="w-100" *ngIf="scenarioSourceType !== 2">
      <app-global-scenario-select-component
        [memberScenarioType]="0"
        [filterNonGM]="false"
        [user]="stateService.getUserGmid()"
        (confirmEvent)="selectGlobalScenario($event)"
        *ngIf="scenarioSourceType === 1"></app-global-scenario-select-component>
      <app-vehicle-scenario-select
        *ngIf="scenarioSourceType === 0"
        titleText="Select Vehicle Scenario"
        [isMultiSelect]="true"
        [validFcorgs]="NON_TVP_FCORGS"
        (confirmEvent)="onSelect($event)">
      </app-vehicle-scenario-select>
    </div>

    <div class="d-flex flex-column justify-content-around" *ngIf="scenarioSourceType === 2">
      <div class="d-flex flex-row gap-16">
        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Forecast Type</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="forecastTypeOptions.selectedOptions"
            [options]="forecastTypeOptions.options">
          </fab-multiselect>
        </mat-form-field>

        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Forecast Gate</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="forecastGateOptions.selectedOptions"
            [options]="forecastGateOptions.options">
          </fab-multiselect>
        </mat-form-field>

        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Propulsion Type</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="propulsionTypeOptions.selectedOptions"
            [options]="propulsionTypeOptions.options">
          </fab-multiselect>
        </mat-form-field>
      </div>

      <div class="d-flex flex-row gap-16">
        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Eng Prog Class</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="engProgClassOptions.selectedOptions"
            [options]="engProgClassOptions.options">
          </fab-multiselect>
        </mat-form-field>
        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Forecast Status</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="forecastStatusOptions.selectedOptions"
            [options]="forecastStatusOptions.options">
          </fab-multiselect>
        </mat-form-field>
        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Market Division</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="marketDivisionOptions.selectedOptions"
            [options]="marketDivisionOptions.options">
          </fab-multiselect>
        </mat-form-field>
      </div>
      <div class="d-flex flex-row gap-16">
        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Architecture</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="architectureOptions.selectedOptions"
            [options]="architectureOptions.options">
          </fab-multiselect>
        </mat-form-field>
        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Local Brand</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="localBrandOptions.selectedOptions"
            [options]="localBrandOptions.options">
          </fab-multiselect>
        </mat-form-field>
        <mat-form-field class="option-dropdown" subscriptSizing="dynamic">
          <mat-label>Program Codes</mat-label>
          <fab-multiselect
            name="subregions"
            [(ngModel)]="programCodeOptions.selectedOptions"
            [options]="programCodeOptions.options">
          </fab-multiselect>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="flex-container flex-row justify-content-center">
    <div class="flex-container flex-row justify-content-center">
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="startYear" id="startYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="endYear" id="endYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex flex-column">
      <mat-checkbox [(ngModel)]="includeZeroVolumes" id="zero-vol">Include Zero Volumes</mat-checkbox>
      <mat-checkbox [(ngModel)]="aggregateTos" id="aggregate-tos" [disabled]="scenarioSourceType === 2">Aggregate Type
        of Sale
      </mat-checkbox>
    </div>
    <div class="d-flex flex-column">
      <mat-checkbox [disabled]="disableIncludeIndustry" [(ngModel)]="includeIndustry" id="include-industry">Include
        Industry Volumes
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="removeRecidNa" id="remove-na">Remove [RECID = NA] Records</mat-checkbox>
    </div>
    <div class="d-flex flex-column">
      <mat-checkbox [(ngModel)]="includeLCA" id="include-lca" [disabled]="scenarioSourceType === 2">Include LCA
        Calculation
      </mat-checkbox>
      <mat-checkbox [disabled]="disableIncludePropulsion" [(ngModel)]="includePropulsion" id="include-propulsion">
        Include Propulsion Volumes
      </mat-checkbox>
    </div>
  </div>
</div>
